module.exports = __webpack_public_path__ + "static/media/tree-right.08cae884.png";